// Api endpoints
export const API_URI = {
  auth: 'api/auth',
  agent: 'api/agent',
  agentgroup: 'api/agentgroup',
  account: 'api/account',
  permission: 'api/permission',
  sampledata: 'api/sampledata',
  service: 'api/service',
  provider: 'api/provider',
  groupprovider: 'api/groupprovider',
  partner: 'api/partner',
  tariff: 'api/tariff',
  pincard: 'api/pincard',
  transaction: 'api/transaction',
  payment: 'api/payment',
  role: 'api/role',
  portaccount: 'api/portaccount'
};

export const Paging = {
  pagesize: 100
}
